module.exports = __webpack_public_path__ + "img/login_time.9810d6e2.png";